export { OrganisationsPage } from './OrganisationsPage'
export { organisationsReducer } from './reducers'


// WEBPACK FOOTER //
// ./src/App/Admin/Organisations/index.js